import { render, staticRenderFns } from "./Readers.vue?vue&type=template&id=8d526ffe&lang=pug"
import script from "./Readers.vue?vue&type=script&lang=js"
export * from "./Readers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports